import { Box, Icon, Typography } from "@mui/material";
import { colors, alphaVar } from "../../../../../theme/muiColors";
import CableIcon from '@mui/icons-material/Cable';

export const Title = ({ title }: { title: string }) => {

  return (
    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", gap: 1, mb: 2 }}>
      <Icon sx={{ fontSize: 32, color: colors.blue[500], backgroundColor: alphaVar(colors.blue[500], 0.2), borderRadius: 1, display: "flex", alignItems: "center", justifyContent: "center", p: 1 }}>
        <CableIcon fontSize="medium" />
      </Icon>
      <Typography variant="h6" sx={{ fontWeight: 500, color: colors.grey[800] }}>{title}</Typography>
    </Box>
  );
};